
(function ($, Drupal, once) {
  'use strict';

  Drupal.behaviors.orgChart = {
    attach: function (context, settings) {
      once('org-chart', '.view-organnigramme', context).forEach(function (viewContainer) {
        const $viewContent = $(viewContainer).find('.view-content');
        const $rows = $viewContent.find('.views-row');

        if ($rows.length === 0) return;

        // 1. Build Data Structure
        const nodes = [];
        const nodeMap = {};

        $rows.each(function (index) {
          const $row = $(this);
          const title = $row.find('.views-field-title .field-content').text().trim();
          // "Superieur" field might be empty for the root node
          const parentName = $row.find('.views-field-field-superieur .field-content').text().trim();

          // Store the original HTML content to preserve Drupal fields/markup
          const contentHtml = $row.html();

          const node = {
            id: index, // Unique ID
            title: title,
            parentName: parentName,
            content: contentHtml,
            children: []
          };

          nodes.push(node);

          // Map by title for easy parent lookup.
          // Warning: Titles must be unique for this to work perfectly.
          // If duplicates exist, this might attach to the last one found.
          nodeMap[title] = node;
        });

        // 2. Build Tree
        const roots = [];

        nodes.forEach(function (node) {
          if (node.parentName && nodeMap[node.parentName]) {
            nodeMap[node.parentName].children.push(node);
          } else {
            // If no parent specified, or parent not found in the list, treat as root
            roots.push(node);
          }
        });

        // 3. Render Tree Helper Function
        function renderTree(nodes) {
          if (nodes.length === 0) return '';

          // Check if we should switch to vertical layout (Grid)
          const shouldStack = nodes.length > 3;
          let ulClass = shouldStack ? 'vertical-children' : '';

          let html = '<ul class="' + ulClass + '">';

          nodes.forEach(function (node) {
            // Check if this is the "Directeur Général" node
            const isDG = node.title.includes('Directeur Général') && !node.title.includes('Adjoin');

            if (isDG) {
              // Look for "Directeur Général Adjoint" in children
              const dgaIndex = node.children.findIndex(n => n.title.includes('Directeur Général Adjoin'));

              if (dgaIndex !== -1) {
                 // Found DGA. We need to render a special structure.
                 const dgaNode = node.children[dgaIndex];
                 // Remove DGA from the standard children array for this render pass
                 // so it doesn't appear twice.
                 // We create a copy of children excluding DGA for the DG's subtree relative to Grid.
                 // However, according to the request, DG and DGA are side-by-side.
                 // We will render a container that holds BOTH.

                 const dgChildren = node.children.filter((_, i) => i !== dgaIndex);

                 html += '<li class="director-level-container">';

                 // Wrapper for the two leaders
                 html += '<div class="leadership-wrapper">';

                   // 1. DG Column
                   html += '<div class="leader-column dg-column">';
                   html +=   '<div class="org-node">' + node.content + '</div>';
                   // Render DG's remaining children (if any)
                   if (dgChildren.length > 0) {
                     html += renderTree(dgChildren);
                   }
                   html += '</div>';

                   // 2. DGA Column
                   html += '<div class="leader-column dga-column">';
                   html +=   '<div class="org-node">' + dgaNode.content + '</div>';
                   // Render DGA's children
                   if (dgaNode.children.length > 0) {
                     html += renderTree(dgaNode.children);
                   }
                   html += '</div>';

                 html += '</div>'; // End leadership-wrapper
                 html += '</li>';
                 return; // Skip standard rendering for this node
              }
            }

            // Standard Rendering
            html += '<li>';
            html += '<div class="org-node">';
            html += node.content;
            html += '</div>';

            if (node.children.length > 0) {
              html += renderTree(node.children);
            }

            html += '</li>';
          });
          html += '</ul>';
          return html;
        }

        // 4. Inject into DOM
        const treeHtml = '<div class="org-chart-wrapper">' + renderTree(roots) + '</div>';
        $viewContent.html(treeHtml);

        // Add a class to the wrapper to signal it's ready/processed
        $(viewContainer).addClass('org-chart-processed');
      });
    }
  };
})(jQuery, Drupal, once);
